import React, { useState, useContext } from 'react';
import { Router, Location, Link } from '@reach/router';
import { AuthContext } from '../../services/auth/AuthProvider';

import RewardCardPacks from './RewardCardPacks/RewardCardParks';
import RewardCards from './RewardCards/RewardCards';
import { useQuery } from '@apollo/react-hooks';
import { useTranslation } from 'react-i18next';
import gem from '../Dashboard/images/gem.svg';
import styles from './Rewards.module.scss'

import card1 from '../../images/new_dashboard/card-1.svg';
import card2 from '../../images/new_dashboard/card-2.svg';
import card3 from '../../images/new_dashboard/card-3.svg';
import cardPack from '../../images/new_dashboard/card-pack.svg';
import cardPrint from '../../images/new_dashboard/card-print.svg';
import cardSort from '../../images/new_dashboard/card-pack-sort.svg';

import RewardPrint from './RewardPrint/RewardPrint';
import { REWARD_CARD_PACK_STASTS } from './services/graphql';

const Rewards = () => {
    const { t } = useTranslation(['rewardcards', 'translation']);
    const { currentUser } = useContext(AuthContext);
    const [selectedPack, setSelectedPack] = useState();
    const [sortOrder, setSortOrder] = useState('desc');
    const { data: packStatsData } = useQuery(REWARD_CARD_PACK_STASTS, {
        fetchPolicy: 'cache-and-network'
    });
    const packStats = packStatsData?.currentStudent?.rewardCardPackStats;
    const packsCompleted = packStats ?
        packStats.filter(pack => pack.total_cards === pack.collected_cards).length :
        undefined;
    return (
        <Location>
            {({ location }) => {
                const isPackDetail = location.pathname.includes('/rewardCardPack/');
                const isRoot = location.pathname === '/rewards' || location.pathname === '/rewards/'

                return <>
                    <div className={styles.rewardsHeader}>
                        <div className={styles.bubblesContainer}>
                            <div className={styles.headerBubble}>
                                <img src={gem} className={styles.bubbleImage} alt={t('translation:gem')} />
                                <p><span className={styles.bubbleValue}>{currentUser.availableGems}</span> {currentUser.availableGems === 1 ? t('translation:gem') : t('translation:gems')}</p>
                            </div>
                            <div className={styles.headerBubble}>
                                <div className={styles.cardsPack}>
                                    <img className={styles.cardLeft} src={card3} alt='card1' />
                                    <img className={styles.cardCenter} src={card2} alt='card1' />
                                    <img className={styles.cardRight} src={card1} alt='card1' />
                                </div>
                                <p><span className={styles.bubbleValue}>{currentUser.cardsCollected}</span> Cards Collected</p>
                            </div>
                            <div className={styles.headerBubble}>
                                <img className={styles.bubbleImage} src={cardPack} alt='cardPack' />
                                <p><span className={styles.bubbleValue}>{packsCompleted}</span> Packs Completed</p>
                            </div>

                        </div>

                        {
                            isPackDetail &&
                            <div className={styles.additionalButtons}>
                                <Link to='/rewards'>
                                    <div className={styles.headerBubble}>
                                        <div className={styles.cardsPack}>
                                            <img className={styles.cardLeft} src={card3} alt='cardLeft' />
                                            <img className={styles.cardCenter} src={card2} alt='cardCenter' />
                                            <img className={styles.cardRight} src={card1} alt='cardRight' />
                                        </div>
                                        <span className={styles.bubbleValue}>Back to packs</span>
                                    </div>
                                </Link>
                                <div className={styles.headerBubble} onClick={() => window.open(`/rewards/rewardPrint/${selectedPack?.id}`, '_blank')}>
                                    <img width={30} src={cardPrint} alt='Card Print' />
                                </div>
                            </div>
                        }

                        {isRoot &&
                            <div className={styles.additionalButtons}>
                                <div className={styles.headerBubble} onClick={() => setSortOrder(prev => prev === 'desc' ? 'asc' : 'desc')}>
                                    <img
                                        width={10}
                                        src={cardSort}
                                        alt='Card Sort'
                                        style={{
                                            transform: sortOrder === 'asc' ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.2s ease',
                                        }}
                                    />
                                    <span className={styles.bubbleValue}>Latest Packs</span>
                                </div>
                            </div>
                        }
                    </div>

                    <Router>
                        <RewardCardPacks
                            path='/'
                            default
                            setSelectedPack={setSelectedPack}
                            sortOrder={sortOrder}
                        />
                        <RewardCards
                            path='/rewardCardPack/:packId'
                            selectedPackData={selectedPack}
                            setSelectedPackToParent={setSelectedPack}
                        />
                        <RewardPrint path='/rewardPrint/:packId' existingSelectedPack={selectedPack} />
                    </Router>
                </>
            }}

        </Location>

    );
}

export default Rewards;
